import type { Middleware } from '@nuxt/types';

const getUserIpMiddleware: Middleware = ({ req, beforeNuxtRender }) => {
  if (!process.server) return;

  const ip = req.headers['x-forwarded-for'];

  beforeNuxtRender(({ nuxtState }) => {
    nuxtState.remoteIP = ip;
  });
};

export default getUserIpMiddleware;
